import {
  faAngleLeft,
  faChevronDown,
  faEye,
  faPen,
  faPlus,
  faTrashCan,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup, Modal, Table } from "react-bootstrap";
import successAnimation from "../../../../../animation/success_lottie/Success_lottie.json";

// import "./Country.css";
import Add_offcanvas from "./add_offcanvas/Add_offcanvas";
import Edit_offcanvas from "./edit_offcanvas/Edit_offcanvas";
import rejectAnimation from "../../../../../animation/success_lottie/Reject_lottie.json";
import Success_modal from "../../../../../common_components/common_modal/success_modal/Success_modal";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../../../utils/IDS";
import CustomPaginate from "../../../../../../common/custompaginate/CustomPaginate";
import { Delete } from "../../../../../../features/admin/masters/country/Slice";
import { FixIDS } from "../../../../../../utils/common";
import { Context } from "../../../../../../utils/context";
import { useDispatch, useSelector } from "react-redux";
import { allAcceptRejectStatus } from "../../../../../../features/admin/common/Slice";
import { UpdateStudyProgramStatus } from "../../../../../../features/admin/courses/studyprogram/Slice";

const Study_Programs = () => {
  const { isAllow: permissions, usertype, userdata } = useContext(Context);
  const isAdmin = userdata?.role === "Admin";
  const dispatch = useDispatch();

  const allacceptrejectstatus = useSelector(
    (state) => state.common.all_accept_reject_status || []
  );

  const [selectedStatus, setSelectedStatus] = useState(null);
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [modalSuccessShow, setModalSuccessShow] = useState(false);
  const [modalErrorShow, setModalErrorShow] = useState(false);

  useEffect(() => {
    if (!allacceptrejectstatus.length) {
      dispatch(allAcceptRejectStatus());
    }
  }, []);

  const handleAcceptReject = async () => {
    if (!selectedStatus || !viewData?.id) return;

    setErr(false);
    setSuccess(false);
    setUpdatingStatus(true);

    const res = await dispatch(
      UpdateStudyProgramStatus({
        id: viewData.id,
        accept_reject_status_id: selectedStatus,
      })
    );

    if (res.meta.requestStatus === "fulfilled") {
      setModalSuccessShow(true);
      setViewData({
        ...viewData,
        accept_reject_status_id: selectedStatus,
      });
      await fetch();
    } else {
      setModalErrorShow(true);
    }

    setUpdatingStatus(false);
  };

  useEffect(() => {
    if (modalSuccessShow || modalErrorShow) {
      const timer = setTimeout(() => {
        setModalSuccessShow(false);
        setModalErrorShow(false);

        // 👇 CLOSE VIEW MODAL ALSO
        setShowViewModal(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [modalSuccessShow, modalErrorShow]);

  const hasPermission = (ids) => {
    if (usertype === "admin") return true;
    if (!Array.isArray(permissions)) return false;
    return ids.some((id) => permissions.includes(id));
  };
  const {
    country,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  } = IndexUse();

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const [modalRejectShow, setModalRejectShow] = useState(false);
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showEditCanvas, setShowEditCanvas] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewData, setViewData] = useState(null);

  const handleView = (row) => {
    setViewData(row);
    setSelectedStatus(null);
    setShowViewModal(true);
  };

  const courseRef = useRef(null);
  const handleStatusSelect = (status) => {
    console.log(status);
    setOpenStatus(false);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);

    if (success) {
      setModalSuccessShow(true);
    } else {
      setModalErrorShow(true);
    }
  };

  const handleDelete = async () => {
    const success = await deleteData(deleteId);

    if (success) {
      setShowDeleteModal(false);
      setDeleteId(null);
      setSuccess(true);
    } else {
      setErr(true);
    }
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (courseRef.current && !courseRef.current.contains(e.target))
        setOpenStatus(false);
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <>
      <section className="Collage_intern application_section">
        <div className="serach_header">
          {/* Search */}
          <InputGroup className="search_box">
            <Form.Control
              placeholder="Search Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="search_input"
            />
            <div className="search_btn">
              <i className="fa fa-search"></i>
            </div>
          </InputGroup>

          <div className="dropdown_wrapper">
            {permissions?.includes(IDS.Permission.Study_Program.Add) && (
              <button
                className="dark_btn"
                disabled={isAdmin}
                onClick={() => {
                  if (isAdmin) return;
                  setShowAddCanvas(true);
                }}
                style={{
                  opacity: isAdmin ? 0.5 : 1,
                  cursor: isAdmin ? "not-allowed" : "pointer",
                }}
              >
                Add
                <div className="aap_icon_holder">
                  <FontAwesomeIcon icon={faPlus} />
                </div>
              </button>
            )}
          </div>
        </div>

        <div className="Dashboard__ActiveApplications card_box">
          <h5 className="mb-3 card_heading_holder">Course</h5>

          <div className="custom_table table_scroll">
            <Table borderless responsive>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>College Name</th>
                  <th>University</th>
                  <th>Course</th>
                  <th>Status </th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {country?.data?.length > 0 ? (
                  country?.data?.map((val, index) => (
                    <tr key={index}>
                      <td>
                        {(country?.current_page - 1) * country?.per_page +
                          index +
                          1}
                      </td>
                      <td>{val?.User?.name}</td>
                      <td>{val?.University?.name}</td>
                      <td>{val?.Course?.name}</td>
                      <td>
                        <Form.Check
                          type="switch"
                          id={`custom-switch-${val?.id}`}
                          checked={val?.status}
                          onChange={() => handleStatusChange(val?.id)}
                          label={val?.status ? IDS.ACTIVE : IDS.INACTIVE}
                        />
                      </td>
                      <td>
                        <div className="action_btn_holder">
                          {/* VIEW */}
                          <Button
                            className="eye_btn action_btn_icon"
                            onClick={() => handleView(val)}
                          >
                            <FontAwesomeIcon icon={faEye} />
                          </Button>

                          {/* EDIT */}
                          {permissions?.includes(
                            IDS.Permission.Study_Program.Edit
                          ) && (
                            <Button
                              className="eye_btn action_btn_icon"
                              disabled={isAdmin}
                              onClick={() => setShowEditCanvas(val?.id)}
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </Button>
                          )}

                          {/* DELETE */}
                          {permissions?.includes(
                            IDS.Permission.Study_Program.Delete
                          ) && (
                            <Button
                              className="eye_btn action_btn_icon"
                              disabled={isAdmin}
                              onClick={() => {
                                if (isAdmin) return;
                                setDeleteId(val.id);
                                setShowDeleteModal(true);
                              }}
                              style={{
                                opacity: isAdmin ? 0.5 : 1,
                                cursor: isAdmin ? "not-allowed" : "pointer",
                              }}
                            >
                              <FontAwesomeIcon icon={faTrashCan} />
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center fw-bold">
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CustomPaginate
              currentPage={country?.current_page}
              totalPages={country?.total_pages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>
      <Add_offcanvas
        show={showAddCanvas}
        setShow={setShowAddCanvas}
        setSuccess={setSuccess}
        setErr={setErr}
        setShowRejectModal={setShowRejectModal}
        handleClose={() => setShowAddCanvas(false)}
      />

      <Edit_offcanvas
        show={showEditCanvas}
        setShow={setShowEditCanvas}
        setSuccess={setSuccess}
        setErr={setErr}
        setShowRejectModal={setShowRejectModal}
        handleClose={() => setShowEditCanvas(false)}
      />

      <Success_modal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        message_text="Application Rejected"
        animationData={rejectAnimation}
      />

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to delete this Course?</Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>

          <Button
            variant="danger"
            onClick={handleDelete} //  THIS IS WHERE YOU CALL IT
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Study Program Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Program Highlights */}
          <h6 className="fw-bold">Program Highlights</h6>
          <ul>
            {viewData?.Study_Program_Highlights?.length > 0 ? (
              viewData.Study_Program_Highlights.map((item, idx) => (
                <li key={idx}>{item?.Program_Highlight?.name}</li>
              ))
            ) : (
              <li>No Program Highlights</li>
            )}
          </ul>

          {/* Eligibility */}
          <h6 className="fw-bold mt-3">Eligibility Requirements</h6>
          <ul>
            {viewData?.Study_Program_Eligibilities?.length > 0 ? (
              viewData.Study_Program_Eligibilities.map((item, idx) => (
                <li key={idx}>{item?.Eligibility_Requirement?.name}</li>
              ))
            ) : (
              <li>No Eligibility Requirements</li>
            )}
          </ul>

          {/* Career */}
          <h6 className="fw-bold mt-3">Career Requirements</h6>
          <ul>
            {viewData?.Study_Program_Careers?.length > 0 ? (
              viewData.Study_Program_Careers.map((item, idx) => (
                <li key={idx}>{item?.Career_Requirement?.name}</li>
              ))
            ) : (
              <li>No Career Requirements</li>
            )}
          </ul>

          {/* Documents */}
          <h6 className="fw-bold mt-3">Requirement Documents</h6>
          <ul>
            {viewData?.Study_Program_Documents?.length > 0 ? (
              viewData.Study_Program_Documents.map((item, idx) => (
                <li key={idx}>{item?.Requirement_Document?.name}</li>
              ))
            ) : (
              <li>No Requirement Documents</li>
            )}
          </ul>

          {isAdmin && viewData && (
            <>
              <hr />
              <h6 className="fw-bold">Application Status</h6>

              {/* Current Status */}
              <Form.Group className="mb-3">
                <Form.Label>Current Status</Form.Label>
                <Form.Control
                  readOnly
                  value={
                    allacceptrejectstatus.find(
                      (s) => s.value === viewData?.accept_reject_status_id
                    )?.label || "Process"
                  }
                />
              </Form.Group>

              {/* Update Status */}
              <Form.Group className="mb-3">
                <Form.Label>Update Status</Form.Label>
                <Form.Select
                  value={selectedStatus ?? ""}
                  onChange={(e) => setSelectedStatus(Number(e.target.value))}
                >
                  <option value="">-- Select Status --</option>
                  {allacceptrejectstatus
                    .filter(
                      (s) =>
                        s.value !== 1 &&
                        s.value !== viewData?.accept_reject_status_id
                    )
                    .map((s) => (
                      <option key={s.value} value={s.value}>
                        {s.label}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>

              {[2, 3].includes(selectedStatus) &&
                selectedStatus !== viewData?.accept_reject_status_id && (
                  <Button
                    onClick={handleAcceptReject}
                    disabled={updatingStatus}
                  >
                    {updatingStatus ? "Updating..." : "Update Status"}
                  </Button>
                )}
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowViewModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalSuccessShow(false)}
        message_text="Status updated successfully!"
        animationData={successAnimation}
      />
    </>
  );
};

export default Study_Programs;
